import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[480px] md:h-[600px] overflow-hidden" aria-labelledby="hero-heading">
      <img
        src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20artistic%20style%20illustration%2C%20warm%20atmospheric%20landscape%2C%20vibrant%20colorful%20cityscape%20with%20fantasy%20elements%2C%20cherry%20blossom%20petals%2C%20soft%20golden%20hour%20lighting%2C%20Korean%20webtoon%20aesthetic%2C%20dreamy%20atmosphere%2C%20artistic%20illustration%20with%20warm%20coral%20and%20amber%20tones%2C%20stylized%20beautiful%20composition&width=1920&height=1080&seq=hero-manhwa-bg&orientation=landscape"
        alt="动漫之家 - 韩国漫画在线免费阅读平台"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4">
        <h1 id="hero-heading" className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
          韩国漫画<span className="text-accent-500">无删减</span>免费阅读
        </h1>
        <p className="text-sm md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          动漫之家专注无删减韩国漫画下拉式呈现，韩漫在线免费阅读热门新作实时更新，画质高清、加载流畅，为您打造优质阅读平台。
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category"
            className="px-8 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            开始阅读
          </Link>
          <Link
            to="/category?sort=rating"
            className="px-8 py-3 rounded-full border border-white/40 text-white font-semibold text-sm hover:bg-white/10 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            热门排行
          </Link>
        </div>

        <div className="flex items-center gap-6 mt-10 md:mt-12">
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">2000+</p>
            <p className="text-xs text-white/70 mt-1">精品漫画</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-accent-500">99.9%</p>
            <p className="text-xs text-white/70 mt-1">高清画质</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <p className="text-2xl md:text-3xl font-bold text-white">500万+</p>
            <p className="text-xs text-white/70 mt-1">忠实读者</p>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center">
          <div className="w-1.5 h-3 bg-white/60 rounded-full mt-2 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}